module.exports = __webpack_public_path__ + "img/footer-logo4.f55e9f61.png";